module.exports = __webpack_public_path__ + "img/20210120.045b556d.png";